<div class="card mt-4">
  <div class="card-body p-4">
    <div class="row g-4">
      <app-form-field class="col-12" label="Exemption type" [includeMargin]="false">
        <app-search
            [options]="exemptionTypes()"
            [formControl]="exemption"
            placeholder="Type to search"
            [required]="exemptionSelected()"
            [inputFormatter]="exemptionRotterdamFormatter">
        </app-search>
        @if (exemptionValue()) {
          <div class="card mt-3">
            <div class="card-body p-3">
              {{ formattedExemptionValue() }}
            </div>
          </div>
        }
      </app-form-field>
    </div>
  </div>
</div>
